module.exports = __webpack_public_path__ + "static/arquitecta-afdf40c799d74cd085cb0b2d3069650f.woff";